import React from "react";
import _isNil from "lodash/isNil";
import { Redirect } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { withOktaAuth } from "@okta/okta-react";

import Login from "./login/Login";
import { LO_STO } from "./util/constants";
import { Paths } from "./constants/global";
import loader from "./images/loader-dots.svg";

const Root = ({ authState }) => {
  const isAuthenticated = authState?.isAuthenticated;
  const currentPath = localStorage.getItem(LO_STO.CURRENT_PATH);
  const pathname = currentPath === Paths.BASE ? Paths.TOKENS : currentPath;

  if (_isNil(isAuthenticated)) {
    return (
      <div id="rootLoader" style={{ position: "fixed", top: "50%", left: "50%" }}>
        <img alt="loader" src={loader} />
      </div>
    );
  }

  return isAuthenticated ? (
    <Redirect to={pathname} />
  ) : (
    <SnackbarProvider maxSnack={3}>
      <Login />
    </SnackbarProvider>
  );
};

export default withOktaAuth(Root);
